import { IMinUser } from '@/Models/User/IUser';
import React, { FC } from 'react';
import { ProductsServerStateProvider } from './Context/ServerState';
import PublicLayout from '@/Components/layouts/PublicLayout';
import Main from './Components/Main';
import { IInitialServerProducts } from './Context/ServerState/actions/getInitialProducts';
import ResponsivePublicLayout from '@/Components/layouts/ResponsivePublicLayout';

interface IUserProductsPageProps {
  user: IMinUser;
  initialProducts: IInitialServerProducts;
  children?: React.ReactNode;
  initialOrderNum: number;
}
const UserProductsNew: FC<IUserProductsPageProps> = ({ children, initialProducts, user, initialOrderNum }) => {
  return (
    <ProductsServerStateProvider initialValue={initialProducts} initialUser={user}>
      <ResponsivePublicLayout visibleMobileNavbar>
        <Main />
      </ResponsivePublicLayout>
    </ProductsServerStateProvider>
  );
};

export default UserProductsNew;

// PUBLIC FOR: USER PRODUCTS PAGE
export { useGetProductsServerValues } from './Hooks/useGetServerValues';
